import { ROUTES } from "../../../api/api.routes";
import useCustomQuery from "../../../hooks/useQuery";
import { Settings } from "../../../types";

export const useSettings = () => {
  const {
    data,
    isLoading,
    mutate,
    ...rest
  } = useCustomQuery<Settings>(ROUTES.Settings);

  return {
    settings: data,
    loadingSettings: isLoading,
    reloadSettings: mutate,
    ...rest
  }
}